import React, { useEffect, useRef } from "react";
import "./CharacterPopupWarningcdmqb.css";

export default function CharacterWarningCDMQB(props) {
  return (
    <div className="characterWarningPageContainerCDMQB">
      <div className="characterWarningBackdropCDMQB" />
      <div
        className="characterWarningContainerCDMQB"
        role="dialog"
        aria-modal="true"
        aria-labelledby="characterWarningHeaderCDMQB"
        aria-describedby="characterWarningBodyCDMQB"
      >
        <div className="characterWarningHeaderContainerCDMQB">
          <h2 id="characterWarningHeaderCDMQB" className="characterWarningHeaderTextCDMQB">
            Maximum Characters
          </h2>
          <button
            type="button"
            className="characterWarningCloseButtonCDMQB"
            aria-label="Close"
            onClick={props.closeMaxCharPopup}
          />
        </div>

        <div className="characterWarningBodyContainerCDMQB">
          <svg
            className="characterWarningIconCDMQB"
            viewBox="0 0 32 32"
            aria-hidden="true"
          ></svg>
          <p id="characterWarningBodyCDMQB" className="characterWarningBodyTextCDMQB">
            Your response must not exceed 100 characters
          </p>
        </div>

        <div className="characterWarningFooterContainerCDMQB">
          <button
            type="button"
            className="characterWarningFooterButtonCDMQB"
            onClick={props.closeMaxCharPopup}
          >
            <span className="characterWarningAccessKeyCDMQB">O</span>k
          </button>
        </div>
      </div>
    </div>
  );
}
